import hasOnlyEmptyRule from 'components/SegmentBuilder/utils/emptyRule';

const mapUiSegmentProperties = segment => {
  return {
    ...segment,
    /* Check if user has selected no filters */
    filters: hasOnlyEmptyRule(segment.filters)
      ? []
      : segment.filters,
    locations: {
      siteIds: [],
      siteUuids: [...segment.locations],
      includeWithoutLocation: segment.includeWithoutLocation,
      locationGroupIds: [],
      dmas: [],
    },
  };
};

export default mapUiSegmentProperties;
